query getMarketSplits($market_id: String, $date_from: Float) {
  getMarketSplits(market_id: $market_id, date_from: $date_from) {
    id,
    market_id,
    split_factor,
    split_date,
    price_multiplier,
    timestamp,
  }
}